import { createReducer, on } from '@ngrx/store';
import * as routerActions from 'src/app/STORE/actions/router.actions';

export interface RouterState {
  event: any;
}

export const initialState: RouterState = {
  event: null
};

export const routerReducer = createReducer(
  initialState,
  on(routerActions.setNavigationEnd, (state, { routerEvent }) => ({
    ...state,
    ...routerEvent
  })),
  on(routerActions.setCurNavigation, (state, { curPage }) => ({
    ...state,
    ...{ curPage }
  })),
  on(routerActions.setCurPage, (state, { currentPage }) => ({
    ...state,
    ...{ currentPage }
  }))
);
